import { Component, inject, OnInit } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxIcon } from '@digipay/ngx-icon';
import { ICustomerAgreement } from '../../../../components/core/models/customer-agreement.interface';

import {
  HOME_ROUTE,
  PROSPECTUS_ROUTE,
  TREASURE_HUNT_NATIONAL_ID_ROUTE,
  TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE,
} from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { CampaignContractGeneratorService } from '../../services/campaign-contract-generator.service';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { HomeService } from '../../../home/services/home.service';
import { NgxCheckboxComponent } from '@digipay/ngx-checkbox';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-campaign-agreements',
  standalone: true,
  imports: [FormsModule, MatCheckboxModule, NgxButtonComponent, NgxIcon, NgxAppBarComponent, NgxCheckboxComponent, SpinnerComponent],
  templateUrl: './campaign-agreements.component.html',
  styleUrl: './campaign-agreements.component.scss',
})
export class CampaignAgreementsComponent implements OnInit {
  state: { campaignCode: string; userInfo: any; agreements: ICustomerAgreement[]; phoneNumber: string };

  checked: boolean;
  agreements: ICustomerAgreement[];
  loading = true;
  contractGeneratorService = inject(CampaignContractGeneratorService);
  pdfSrc: {
    creditContract: Blob;
    customerAndBrokerContract: Blob;
    buyAndSellContract: Blob;
    seke2AssuranceFundContract: Blob;
    iMEUnderWritingRiskStatementContract: Blob;
  };
  isUploading = false;
  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);

  constructor(private homeService: HomeService) {
    this.state = this.routeState.getAll();
    if (!this.state.campaignCode) this.navigationService.navigate(HOME_ROUTE);
    this.agreements = this.state.agreements;
  }

  ngOnInit(): void {
    this.getPdfs();
  }

  async getPdfs() {
    this.pdfSrc = await this.contractGeneratorService.getContracts(this.state.userInfo);

    this.loading = false;
  }

  onBackHandler() {
    this.navigationService.navigateWithState([TREASURE_HUNT_NATIONAL_ID_ROUTE], {
      state: {
        campaignCode: this.state.campaignCode,
        userInfo: this.state.userInfo,
        agreements: this.state.agreements,
        phoneNumber: this.state.phoneNumber,
      },
    });
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string); // Base64 string
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async confirmAgreement() {
    this.isUploading = true;
    this.homeService.getCampaignProcess(this.state.campaignCode, null, { agreementApprovement: true }).subscribe((res) => {
      if (res?.success) {
        this.navigationService.navigateWithState([TREASURE_HUNT_REGISTRATION_SUCCESSFUL_ROUTE], {
          state: {
            remainingDays: res.result.data.remainingDays,
          },
        });
      }
    });
  }

  displayAgreement(agreement: ICustomerAgreement) {
    const convertToCamelCase = (input: string): string => (input.length === 0 ? '' : input.charAt(0).toLowerCase() + input.slice(1));
    const contractCamelCaseName = convertToCamelCase(agreement.key);
    this.navigationService.navigateWithState([PROSPECTUS_ROUTE], {
      state: {
        pdfFile: this.pdfSrc[contractCamelCaseName + 'Contract'],
        symbol: 'IRTKGANJ0001',
        type: 'campaign',
        agreement: agreement.key,
        agreementTitle: agreement.description,
        campaignData: {
          campaignCode: this.state.campaignCode,
          userInfo: this.state.userInfo,
          agreements: this.state.agreements,
        },
      },
    });
  }
}
